import { pad } from "../../qa";
import styles from "./SetSummary.module.css";

const SYMBOL = { correct: "✓", incorrect: "×", unverified: "–" };

export default function SetSummary({
  set,
  statuses,
  teamStatuses,
  score,
  answered,
  claimedBy,
  signers,
  iClaimed,
  iSigned,
  onClaim,
  onSign,
  onReset,
}) {
  const state = signers.length
    ? `Checked by ${signers.join(", ")}`
    : claimedBy
      ? `In review by ${claimedBy}`
      : "Unchecked";

  return (
    <section className={styles.summary} aria-labelledby="qa-summary-title">
      <header className={styles.head}>
        <h2 id="qa-summary-title" className={styles.title}>
          Set {pad(set.id)} / Verification
        </h2>
      </header>
      <p className={`${styles.state} ${signers.length ? styles.done : ""}`} role="status">
        <span>Set status</span>
        <strong>{state}</strong>
      </p>
      <div className={styles.body}>
        <ul className={styles.rows}>
          {set.questions.map((q) => (
            <li key={q.id} className={styles.row}>
              <span>Q{pad(q.index)}</span>
              <span className={styles.diff}>{q.difficulty}</span>
              <span className={styles.symbol} title="You / Team">
                {SYMBOL[statuses[q.id]]}
                <span className={styles.team}>{SYMBOL[teamStatuses[q.id]]}</span>
              </span>
            </li>
          ))}
        </ul>
        <div className={styles.figure}>
          <span className={styles.label}>My score</span>
          <span className={styles.big}>{score} / {set.total}</span>
        </div>
        <div className={styles.figure}>
          <span className={styles.label}>My checks</span>
          <span className={styles.big}>{answered} / {set.questions.length}</span>
          <span className={styles.sub}>Verified</span>
        </div>
      </div>
      <div className={styles.actions}>
        <button
          type="button"
          className={`${styles.action} ${styles.primary} ${iSigned ? styles.marked : ""}`}
          aria-pressed={iSigned}
          onClick={onSign}
        >
          {iSigned ? "✓ I checked this set" : "Mark set checked"}
        </button>
        <button type="button" className={styles.action} aria-pressed={iClaimed} onClick={onClaim} disabled={iSigned}>
          {iClaimed ? "Release set" : "Claim set"}
        </button>
        <button type="button" className={styles.action} onClick={onReset}>
          Reset my checks
        </button>
      </div>
    </section>
  );
}
